import { render, staticRenderFns } from "./BuildingTimeDivisionCard.vue?vue&type=template&id=8f2edc44&scoped=true&"
import script from "./BuildingTimeDivisionCard.vue?vue&type=script&lang=js&"
export * from "./BuildingTimeDivisionCard.vue?vue&type=script&lang=js&"
import style0 from "./BuildingTimeDivisionCard.vue?vue&type=style&index=0&id=8f2edc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2edc44",
  null
  
)

export default component.exports